function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.898 5.5A6.501 6.501 0 008.78 9.798h4.668a.75.75 0 110 1.5H8.436a6.575 6.575 0 000 1.4h2.113a.75.75 0 010 1.5H8.781a6.501 6.501 0 0010.016 3 .75.75 0 11.901 1.2 8.002 8.002 0 01-12.493-4.199H4.75a.75.75 0 010-1.5h2.18a8.102 8.102 0 010-1.4H4.75a.75.75 0 110-1.5h2.455A8.002 8.002 0 0119.698 5.6a.75.75 0 01-.9 1.2 6.467 6.467 0 00-3.9-1.3z",
  fill: "#313D53"
})));